import { render, staticRenderFns } from "./UserBlocked.vue?vue&type=template&id=1fc725f0&scoped=true&"
import script from "./UserBlocked.vue?vue&type=script&lang=js&"
export * from "./UserBlocked.vue?vue&type=script&lang=js&"
import style0 from "./UserBlocked.vue?vue&type=style&index=0&id=1fc725f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc725f0",
  null
  
)

export default component.exports